export interface RefreshReportOptions {
  additionalDataParams?: unknown;
  additionalReportParams?: unknown;
  manual?: boolean;
  manualDrilldown?: boolean;
}

export interface LinkOptions {
  isReport?: boolean;
  tabId?: number;
  columnsFromCache?: boolean;
  replaceColumnsWithCurrent?: boolean;
}

export enum ExcludeTypeEnum {
  concat = 'concat',
  slice = 'slice',
}

export interface NextReportProps {
  tableNextReport?: unknown;
  tableNextReportName?: string;
  tableNextReportGroup?: unknown;
  tableSelectedItems?: unknown[];
  tableNextReportExclude?: boolean;
  tableNextReportExcludeType?: ExcludeTypeEnum;
  tableNextReportOnlyDrill?: boolean;
}
